import { IState } from "..";
import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "../../app/store";
import TerminalService from "../../app/data/terminal-details/terminalService";
import { initialDeleteTerminalState } from "./DeleteState";

const terminalService = TerminalService.getInstance();

export const deleteTerminalSlice = createSlice({
    name: "deleteTerminal",
    initialState: initialDeleteTerminalState,
    reducers: {
        loading: (state) => {
            state.isLoading = true;
            state.isSuccess = false;
            state.isError = false;
            state.errorMessage = null;
        },
        setSuccess: (state) => {
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = true;
            state.errorMessage = null;
        },
        error: (state, { payload }) => {
            state.isLoading = false;
            state.isError = true;
            state.isSuccess = false;
            state.errorMessage = payload;
        }
    },
});

export const {
    loading,
    error,
    setSuccess
} = deleteTerminalSlice.actions;

export const deleteTerminalSelector = (state: IState) => state.deleteTerminal;

export const deleteTerminalById = (terminalNumber: string, onSuccess?: () => void): AppThunk => async (dispatch) => {
    if (!terminalNumber) return
    dispatch(loading());
    const response = await terminalService.deleteTerminalByTerminalNumber(terminalNumber);
    if (response.ok()) {
        dispatch(setSuccess());
        onSuccess?.();
    } else {
        dispatch(error(response.getError()));
    }
};

const deleteTerminalReducer = deleteTerminalSlice.reducer;
export default deleteTerminalReducer;
